import { cn } from '~/utils'
import { Plan } from '../types'
import { getOrderedPlansInfo } from '../utils/plan'
import { Check, X } from 'lucide-react'

export const PlanSummary = ({ plan, upgrade }: { plan: Plan; upgrade: boolean }) => {
  const availablePlans = getOrderedPlansInfo()
  const currentPlanInfo = availablePlans[plan]

  const planPerks = [...currentPlanInfo.features, ...(currentPlanInfo.addons?.map((addon) => addon.display) ?? [])]
  return (
    <div>
      <div
        className={cn(
          'flex w-full flex-col gap-2 rounded-t-xl p-6 text-white',
          currentPlanInfo.backgroundUrl ?? 'bg-gray-400'
        )}
        style={
          currentPlanInfo.backgroundUrl
            ? {
                backgroundImage: `url(${currentPlanInfo.backgroundUrl})`,
                backgroundSize: 'cover',
              }
            : undefined
        }
      >
        <div className="text-2xl font-semibold">{currentPlanInfo.displayName}</div>
        <div className="text-sm">Your current plan</div>
      </div>
      <div className="grid gap-4 overflow-auto rounded-b-xl bg-gray-1 p-6 max-sm:max-h-[20vh] max-sm:grid-cols-1 sm:grid-flow-col sm:grid-rows-4">
        {planPerks.map((perk, index) => (
          <div className="flex items-center gap-2 text-xs font-medium" key={index}>
            {upgrade ? <Check className="h-4 w-4 text-green-4" /> : <X className="h-4 w-4 text-danger" />}
            {perk}
          </div>
        ))}
      </div>
    </div>
  )
}
